import { render, staticRenderFns } from "./item-bar.vue?vue&type=template&id=481bce85&scoped=true"
import script from "./item-bar.vue?vue&type=script&lang=js"
export * from "./item-bar.vue?vue&type=script&lang=js"
import style0 from "./item-bar.vue?vue&type=style&index=0&id=481bce85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bce85",
  null
  
)

export default component.exports